import React from 'react';
import { useSelector } from 'react-redux';
import { MdContentCopy } from 'react-icons/md';

import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER
} from 'components/RoleGate/constants';
import RoleButton from 'components/RoleButton';
import SingleActiveTableRowGate from 'components/SingleActiveTableRowGate';
import ButtonIconWrapper from 'components/ButtonIconWrapper';
import { FERTILIZER_EVENT_COPY_MODAL } from 'scenes/Fertilizer/constants';
import { AppState } from 'services/types';
import { makeSelectCopyFertilizerEventUuid } from './selectors';

export default function FertilizerEventCopyButton(): React.ReactElement | null {
    const fertilizerEventUuid = useSelector((state: AppState) =>
        makeSelectCopyFertilizerEventUuid()(state)
    );

    if (!fertilizerEventUuid) {
        return null;
    }

    return (
        <SingleActiveTableRowGate>
            <RoleButton
                requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}
                params={{
                    [FERTILIZER_EVENT_COPY_MODAL]: true,
                    fertilizerEventUuid
                }}
                buttonProps={{
                    icon: true,
                    color: 'black',
                    basic: true,
                    style: {
                        margin: 0
                    }
                }}
            >
                <ButtonIconWrapper>
                    <MdContentCopy
                        style={{
                            fontSize: 20
                        }}
                    />
                </ButtonIconWrapper>
                Copy
            </RoleButton>
        </SingleActiveTableRowGate>
    );
}
